import { useNavigate, useLocation } from 'react-router-dom';
import { FaCalculator, FaFileAlt, FaBars } from 'react-icons/fa';
import { categories } from '../utils/staticData'


function AppNav({ isOpen, setIsOpen }) {
    const navigate = useNavigate();
    const { search } = useLocation();

    const toggleNav = () => {
        setIsOpen(!isOpen);
    };

    const handleNavigate = (path) => {
        navigate(path + search);
        setIsOpen(false);
    };

    return (
        <div className="app-nav-container">
            <button className="btn btn-primary nav-toggle-btn" onClick={toggleNav}>
                <FaBars /> Select Form
            </button>
            <div className={`nav-menu ${isOpen ? 'open' : ''}`}>
                <div className="container py-4 overflow-y-auto" style={{ maxHeight: '80vh' }}>
                    {Object.keys(categories).map(category => (
                        <div key={category} className="mb-4">
                            <h5 className="text-primary fw-bold fs-2 border-bottom pb-2 mb-3 d-flex align-items-center gap-2">
                                {category === 'Calculators' ? <FaCalculator /> : <FaFileAlt />}
                                {category}
                            </h5>
                            <div className="list-group">
                                {categories[category].map((item, index) => (
                                    <button
                                        key={index}
                                        className="fw-bold fs-5 list-group-item list-group-item-action"
                                        onClick={() => handleNavigate(item.path)}
                                    >
                                        {item.title}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AppNav;